import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap';
import { RecruitersPopoverComponent } from './recruiters-popover.component';

@NgModule({
  declarations: [RecruitersPopoverComponent],
  imports: [
    CommonModule,
    TooltipModule.forRoot()
  ],
  exports: [RecruitersPopoverComponent],
  entryComponents: [RecruitersPopoverComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class RecruitersPopoverModule { }
